import { BlurbCard, Grid, GridCell, Link } from 'ui/components';

import styles from './List.module.scss';
import { JSX } from 'react';

export interface ListProps {
	items: Models.BlurbCard[];
	desktopWidth?: Models.GridCellWidth;
	mobileWidth?: Models.GridCellWidth;
	link?: Umbraco.Link;
}

export const List: React.FC<ListProps> = ({ items, desktopWidth = '100', mobileWidth = '100', link }) => {
	if (!items) return null;

	let gridLink: JSX.Element;
	if (link) {
		gridLink = (
			<GridCell desktopWidth={desktopWidth} mobileWidth={mobileWidth} center={true}>
				<div className={styles.List}>{link && <Link url={link.url}>{link.name}</Link>}</div>
			</GridCell>
		);
	}

	const grid = (
		<Grid wrap={true}>
			{items.map((args, index) => (
				<BlurbCard key={index} {...args} />
			))}
			{gridLink}
		</Grid>
	);

	return grid;
};
